module.exports = __webpack_public_path__ + "static/media/oval-closed.5ce12a5d.svg";